<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row mt-5 pt-3">
        <div class="col-11 mt-2">
          <input 
            v-model="searchN" 
            type="text" 
            class="form-control" 
            id="exampleFormControlInput1"
            placeholder="Buscar historial de compras por Cédula"
            autocomplete="off"
            v-on:focus="clearInput"
          />
        </div>
        <div class="col-1 mt-2">
          <button class="btn btn-danger btn-block" @click="search()">
            <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <div class="commentary">
            <span>El orden de los productos va según los puntos, de menor a
              mayor.</span>
          </div>
        </div>
      </div>
      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-danger" style="width: 4em; height: 4rem;" role="status"></div>
        </div>
      </template>
      <paginate v-else class="ul-pagination" name="items" :list="items" :per="10">
        <div class="row mt-1">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <caption class="visually-hidden">Listado Historial</caption>
                <thead>
                <tr>
                  <th scope="col" style="text-align: left">Nombre</th>
                  <th scope="col" style="text-align: left">Cédula</th>
                  <th scope="col" style="text-align: left">ID</th>
                  <th scope="col" style="text-align: left">Puntos</th>
                  <th scope="col" style="text-align: left">Fecha</th>
                  <th scope="col" style="text-align: left">Estado</th>
                  <th scope="col" style="text-align: left">Detalles</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in paginated('items')" :key="'d' + `item-${i}`">
                  <td style="text-align: left">
                    {{ item.user_info.name + ' ' + item.user_info.last_name }}
                  </td>
                  <td style="text-align: left">
                    {{ item.user_info.document_number }}
                  </td>
                  <td style="text-align: left">
                    {{ item.id }}
                  </td>
                  <td style="text-align: left">
                    <h6>
                        <span class="badge badge-pill badge-danger">Puntos:
                          {{ item.total_points }}
                        </span>
                    </h6>
                  </td>
                  <td style="text-align: left">
                      {{ item.order_date }}
                  </td>
                  <td style="text-align: left" >
                    <label :style="(item.status_id == 4 ? 'color:#dc3545':'color:grey')">
                      {{(item.status_id == 4 ? 'Aprobado':'Rechazado')}}
                    </label>
                  </td>
                  <td style="text-align: left">
                      <button @click="getDetails(item)" type="button" class="btn btn-primary" data-toggle="modal">
                        <span class="fa-solid fa-eye"></span>
                      </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </paginate>
      <div class="row ">
        <div class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2">
          <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
        </div>
        <div class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate">
          <paginate-links @change="pageChange" for="items" :limit="2" :show-step-links="true"
                          :step-links="{ next: '>', prev: '<' }" :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }">
          </paginate-links>
        </div>
      </div>
      <!-- Modal -->

      <div class="modal fade" 
      id="exampleModal" 
      tabindex="-1" 
      aria-labelledby="exampleModalLabel" 
      aria-hidden="true">

        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel" style="color: red;">Información de la orden</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-dark">
              
              <table class="table">
                <caption class="visually-hidden">Listado Historial</caption>
                <thead>
                  <tr>
                    <th scope="col" style="text-align: left">#</th>
                    <th scope="col" style="text-align: left">Nombre</th>
                    <th scope="col" style="text-align: left">Precio</th>
                    <th scope="col" style="text-align: left">Orden</th>
                    <th scope="col" style="text-align: left">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(detalles, i) in detailOrders" :key="i">
                    <th scope="row">{{i + 1}}</th>
                    <td style="text-align: left">{{detalles.product.name}}</td>
                    <td style="text-align: left">{{detalles.product.price}}</td>
                    <td style="text-align: left">{{detalles.order_id}}</td>
                    <td style="text-align: left">{{detalles.status.name}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      listFile: [],
      searchN: "Buscar historial de compras por Cédula",
      loading: {
        publicate: false,
        history: false,
        changeDoc: false,
        order: false
      },
      hidden: {
        btn: false
      },
      paginate: ["items"],
      page: 1,
      totalPage: 1,
      isWon: false,
      totalProductOrders: 9999,
      detailOrders: [],
    };
  },
  methods: {
    search() {
      this.items = [];
      this.loading.history = true;
      axios
            .post("api/orders/get",{
                "document_number": this.searchN,
                "limit": this.totalProductOrders,
            })
            .then(res => {
              if (res.data.cod == 0) {
                this.items = res.data.data.data;
                this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
              }
              this.loading.history = false;
            })
            .catch(error => {
              this.loading.history = false;
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: error.response.data.message
              });
            });
    },
    getProducts() {
      this.items = [];
      this.loading.history = true;
      this.totalProductOrders = 9999;

      axios
      .post("api/orders/get",{
          'page': this.totalPage,
          'limit': this.totalProductOrders
      })
      .then(res => {
          if(res.data.cod == 0){
              this.items = res.data.data.data;
              console.log(this.items);
              this.totalProductOrders = res.data.data.total
              this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
              this.getIdDetails = res.data.data.data.order_date;
          }
          this.loading.history = false;
      })
            .catch(function (error) {
                console.log(error);
            })
    },
    getDetails(data){
        axios
        .post("api/product/get/order/" + data.id)
        .then(res => {
          if(res.data.cod == 0){
            $("#exampleModal").modal("show"); 
            this.detailOrders = res.data.data.data[0].order_product;
          }
        })
        .catch(function (error) {            
            $("#exampleModal").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
        })
    },
    pageChange(toPage) {
      this.page = toPage;
    },
    clearInput() {
      this.searchN = "";
    },
  },
  mounted() {
    this.pageChange(1);
    this.getProducts();
    this.getDetails();
  },
  watch: {
    searchN: function (newN) {
        if (!newN) {
          setTimeout(() => this.getProducts(), 15000);
        }
      },
  }
};
</script>

<style>
.container-fluid {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
label {
  color: black;
  margin-right: 4px;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.ul-pagination {
  padding: 0px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>